import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { LoadTable, VirtualTable } from "..";
import { LoadReceipt } from "../FormComponents/AddPickupMemo/AddLRAutoLR/PickupMemoTypes";
import PortalFooter from "../Reactportal/PortalFooter";
import Reactportal from "../Reactportal/Reactportal";
import "./LRTable.scss";
import { useModalContext } from "../Reactportal/ModalContext";
import { useEventListener } from "usehooks-ts";

const AddAutoLRtable = ({
  addLR,
  show,
  TypeOfPortal,
  fielddata,
  setAutoLR,
  parentID,
  data,
  SelectedData = [],
  formkey,
  loading = false,
}) => {
  const [openLRModal, setOpenLRModal] = useState(show);
  // eslint-disable-next-line
  const [alldata, setalldata] = useState<LoadReceipt[]>([]);
  const [combinedData, setCombinedData] = useState<LoadReceipt[]>([]);
  const [selectedFirst, setSelectedFirst] = useState<LoadReceipt[]>([]);
  const { pushModal, popModal, getTopModal } = useModalContext();
  const Form_Key = "LR_Material_Table";
  const SelectedRowsData = useSelector((store: any) => store?.UniqueTableReducer?.LR_Data);
  const SelectedRowsData1 = useSelector((store: any) => store?.UniqueTableReducer?.New_Branches?.Selected_Rows);
  // const SelectedRowsData2 = useSelector((store: any) => store?.FormFieldData?.salesBillselectedRows);

  // const dispatch = useDispatch();

  const Closeformfunction1 = () => {
    setAutoLR();
    setOpenLRModal(false);
    popModal(Form_Key);
    // dispatch({ type: "ClearData", payload: { data: {} } });
  };
  useEffect(() => {
    // if (SelectedRowsData1?.length > 0) {
    //   setSelectedFirst(SelectedRowsData1)
    // }
    // else {

    // }
    setSelectedFirst(SelectedRowsData1);
  }, [SelectedRowsData1]);

  useEffect(() => {
    if (openLRModal) {
      pushModal(Form_Key);
    }
  }, [openLRModal, Form_Key, pushModal]);

  useEffect(() => {
    if (SelectedRowsData?.Selected_Rows?.length > 0) {
      // let newData = [...SelectedRowsData?.Selected_Rows, ...alldata];
      // newData = newData?.filter((item, index, self) => index === self.findIndex((t) => t.LR_No === item.LR_No));
      setCombinedData(SelectedRowsData?.Selected_Rows);
    } else {
      setCombinedData([]);
    }
  }, [SelectedRowsData, alldata]);

  useEffect(() => {
    if (SelectedData?.length > 0) {
      setSelectedFirst([...SelectedData]);
    } else {
      setSelectedFirst(SelectedData);
    }
  }, [SelectedData]);
  // const handleAddDataFunction = (newData: LoadReceipt) => {
  //   const combinedData = [...SelectedRowsData?.Selected_Rows, ...alldata];
  //   if (!combinedData?.some((item) => item.LR_No === newData.LR_No)) {
  //     setalldata([...alldata, newData]);
  //   } else {
  //     ErrorToast("LR No already exists!");
  //   }
  // };

  // Function to handle keyboard events
  const handleKeyDown = (event) => {
    if (getTopModal() === Form_Key) {
      if (event.key === "Escape") {
        Closeformfunction1();
      } else if (event.key === "F4" && !TypeOfPortal?.includes("View")) {
        submit();
      }
    }
  };

  // Use the useEventListener hook from usehooks-ts to listen for keydown events
  useEventListener("keydown", handleKeyDown);

  const submit = () => {
    Closeformfunction1();
    setTimeout(() => {
      addLR(selectedFirst);
    }, 100);
    // dispatch({ type: "lrPickupMemo", payload: { data: combinedData } });
  };

  return (
    <>
      {openLRModal ? (
        <Reactportal open={openLRModal} onClose={Closeformfunction1} TypeOfPortal={TypeOfPortal}>
          <div className="mainpickup lr-table-container">
            <div className="pickupdata1">
              {loading ? (
                <p style={{ textAlign: "center" }}>Loading...</p> // Replace with your loader component if you have one
              ) : !data?.length ? (
                <p style={{ textAlign: "center" }}>Data not available</p>
              ) : (
                <VirtualTable
                  data={data}
                  title={"LR_Data"}
                  selectedRows={selectedFirst}
                  multiSelect={formkey === "Sales_Return" ? false : true}
                  ledgerTable=""
                  dragDrop={true}
                />
              )}
            </div>
            {data?.length ? (
              <div className="pickupdata1">
                {!combinedData?.length ? (
                  <p style={{ textAlign: "center" }}>No LR Selected</p>
                ) : (
                  <LoadTable
                    data={combinedData}
                    loading={false}
                    error={null}
                    title={"New_Branches"}
                    // TableHeaders={[["Total_Number_Of_Boxes", "Total Number Of Boxes", "Total_Number_Of_Boxes", true]]}
                    selectedRows={combinedData}
                  />
                )}
              </div>
            ) : (
              ""
            )}
          </div>
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitform={submit}
            SaveAndClose={() => {
              Closeformfunction1();
              submit();
            }}
            handleformclose={() => {
              Closeformfunction1();
              setOpenLRModal(!openLRModal);
            }}
          />
        </Reactportal>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default AddAutoLRtable;
